import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getKeyHandler } from '../structure/FlowForm';
import './SvgButton.css';
const SvgButton = ({ focusId, children, focussable = 'sideway', size = 'medium', onClick, type = 'minor', disabled = false, sidewaysBehaviour = 'both', className, onKeyPress, title }) => {
    const [clicked, setClicked] = React.useState(false);
    const handleKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour,
        onAction: () => {
            setClicked(true);
            setTimeout(() => setClicked(false), 200);
            onClick === null || onClick === void 0 ? void 0 : onClick(true);
        },
        defaultHandler: onKeyPress
    });
    return (_jsxs("button", { id: focusId, className: `svgButton ${size}${focussable != 'normal' && !disabled ? ' flowFocussable' : ''}${focussable == 'sideway' && !disabled ? ' sidewayFocus' : ''} ${type} ${clicked ? 'clicked' : 'unclicked'} ${disabled ? 'disabled' : 'enabled'} ${className ? ' ' + className : ''}`, tabIndex: disabled ? -1 : 0, title: title, onClick: (ev) => { ev.preventDefault(); ev.stopPropagation(); onClick === null || onClick === void 0 ? void 0 : onClick(false); }, onKeyDown: handleKeyDown, disabled: disabled, children: [_jsx("div", { className: 'background' }), _jsx("div", { className: 'svgContent', children: children })] }));
};
export default SvgButton;
